import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { PackageDeal } from './package-deal.class';

export class PackageDealCalculated extends BaseEntity {
	packageDealId: string;

	@Type(() => PackageDeal)
	packageDeal: PackageDeal;

	pricePerVehicle: number;
}
